import React, { useState } from 'react';
import { SmartDataTable } from '@src/components/SmartDataTable';
import { usePurchaseOrdersColumns, usePurchaseOrdersFormFields } from './hooks';
import { PaymentFormModal } from '@src/pages/payments/components';
import { useInvalidate } from '@refinedev/core';

export const PurchaseOrdersPage = () => {
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [paymentInitialValues, setPaymentInitialValues] = useState<any>({});
  const invalidate = useInvalidate();

  const handleCreatePayment = (transactionData: {
    transaction_type: 'po';
    po_id: number;
    amount: number;
    supplier: any;
    type: string;
  }) => {
    setPaymentInitialValues({
      type: transactionData.type || 'MEDICAL_PURCHASES',
      reference_id: transactionData.po_id,
      transaction_type: 'DEBIT',
      amount: transactionData.amount,
    });
    setPaymentModalVisible(true);
  };

  const handlePaymentSuccess = () => {
    // Invalidate purchase orders to refresh the data
    invalidate({
      resource: 'purchase-orders',
      invalidates: ['list'],
    });
    invalidate({
      resource: 'payments',
      invalidates: ['list'],
    });
    setPaymentModalVisible(false);
    setPaymentInitialValues({});
  };

  const columns = usePurchaseOrdersColumns({
    onCreateTransaction: handleCreatePayment,
  });
  const formFields = usePurchaseOrdersFormFields();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SmartDataTable
        api={{
          resource: 'purchase-orders',
        }}
        title="Purchase Orders"
        columns={columns}
        search={{
          enabled: true,
          fields: ['id', 'invoice_no', 'supplier_name'],
          placeholder: 'Search by ID, invoice number, or supplier...',
          debounceMs: 500,
        }}
        createForm={{
          fields: formFields() as any,
          title: 'Create Purchase Order',
          submitText: 'Create Order',
        }}
        dynamicEditForm={{
          getForm: record => ({
            fields: formFields(record) as any,
            title: 'Edit Purchase Order',
            submitText: 'Save Changes',
          }),
          getResource: () => 'purchase-orders',
        }}
        formDisplayMode="drawer"
        drawerWidth={'100%'}
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        pageSize={10}
        showSizeChanger={true}
        showQuickJumper={false}
        showExport={true}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 300px)',
          },
        }}
        rowKey="id"
      />

      <PaymentFormModal
        visible={paymentModalVisible}
        onClose={() => {
          setPaymentModalVisible(false);
          setPaymentInitialValues({});
        }}
        onSuccess={handlePaymentSuccess}
        initialValues={paymentInitialValues}
      />
    </div>
  );
};
